import { createContext, useCallback, useContext, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { invalidatePaymentRequests } from "@api/queryKeys";
import PaymentRequestDetails from "@areas/payments/displays/PaymentRequestDetails";
import PlanDetailModal from "@areas/calendar/displays/PlanDetailModal";

const PaymentRequestDrawerContext = createContext(null);

export const usePaymentRequestDrawer = () =>
  useContext(PaymentRequestDrawerContext) ?? { openPaymentRequest: () => {} };

// Mounts the payment-request detail sidebar once, app-wide, so anything (e.g. a notification) can
// open a request as a drawer over the current page instead of navigating to the payments page.
export function PaymentRequestDrawerProvider({ children }) {
  const queryClient = useQueryClient();
  const [requestId, setRequestId] = useState(null);
  const [planActionId, setPlanActionId] = useState(null);

  const openPaymentRequest = useCallback((id) => setRequestId(id), []);

  return (
    <PaymentRequestDrawerContext.Provider value={{ openPaymentRequest }}>
      {children}
      <PaymentRequestDetails
        paymentRequestId={requestId}
        onClose={() => setRequestId(null)}
        onChange={() => invalidatePaymentRequests(queryClient)}
        onViewPlan={setPlanActionId}
        compactActions
        elevated
      />
      <PlanDetailModal
        actionId={planActionId}
        isOpen={!!planActionId}
        onClose={() => setPlanActionId(null)}
        elevated
      />
    </PaymentRequestDrawerContext.Provider>
  );
}
